<template>
  <section class="inner-page">
    <h4>Favoritos</h4>
    <h6>Pontos de interesse</h6>
    <section>
      <div class="interest-points" v-if="interestPoints">
        <interestPointItem :interestPoint="interestPoint.interest_point" 
        :url="$store.state.user.is_admin ? '/admin/interestPoint/' + interestPoint.interest_point.id : 
        '/pontoDeInteresse/' + interestPoint.interest_point.id" 
        v-for="interestPoint in interestPoints" :key="interestPoint.id"/>
      </div>
    </section>
  </section>
</template>
<script>
import interestPointItem from '../../../components/interest-point-item.vue'
export default {
  components: { interestPointItem },
  data () {
    return {
      interestPoints: null
    }
  },
  async mounted () {
    let data = await this.api.get('/user/favorite')
    this.interestPoints = data.filter(i => i.interest_point)
  }
}
</script>
<style lang="scss" scoped>
h4 {
  margin-bottom: 48px;
}
h6 {
  font-weight: 500;
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 24px;
  font-stretch: condensed;
  line-height: 1.08;
  letter-spacing: 0.6px;
  color: #a79374;
}
.interest-points {
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
}
.interest-points a {
  margin: 0 20px;
  width: calc(100% / 4 - 40px);
  &:nth-of-type(4n + 1) {
    margin-left: 0;
  }
  &:nth-of-type(4n) {
    margin-right: 0;
  }
}
.interest-points /deep/ .interest-point-item {
    margin-bottom: 40px;
    position: relative;
    & > .image {
      max-height: 200px;
      width: 100%;
      img {
        width: 100%;
      }
    }
    h2 {
      font-weight: bold;
      font-size: 18px;
      line-height: 1.22;
      letter-spacing: -0.4px;
      color: #a79374;
      margin-top: 16px;
    }
    p {
      font-size: 16px;
      line-height: 1.5;
      color: #a79374;
    }
}
</style>